import { Collapse } from "@mui/material";
import { EntriesTableCell } from "../styles";
import { Refs } from "../types";
import { useAppSelector } from "../../../app/hooks";

const CollapsibleHeaders = ({
  open,
  isFirstGroup,
  allHeaders,
  entryHeaders,
  refs,
}: {
  open: boolean;
  isFirstGroup: boolean;
  allHeaders: string[];
  entryHeaders: string[];
  refs: Refs<any[]>;
}) => {
  const { translatedExpenseTypes } = useAppSelector((state: any) => ({
    translatedExpenseTypes: state.localized.expenseType,
  }));

  return open ? (
    <Collapse
      in={open}
      orientation="horizontal"
      timeout={{ exit: 100, enter: 100 }}
      sx={{ overflow: "hidden" }}
    >
      {/* TODO: not sure if this works with real data */}
      {!isFirstGroup &&
        allHeaders.map((item, index) => (
          <EntriesTableCell
            key={index}
            borderLeft={index === 0 || entryHeaders.includes(item)}
            noBorder={!entryHeaders.includes(item)}
            align="center"
            sx={{
              color: "text.secondary",
              visibility: entryHeaders.includes(item) ? "visible" : "hidden",
              borderBottom: "none",
              verticalAlign: "middle",
            }}
            ref={(el: any) =>
              // @ts-ignore TODO: FIX
              (refs.current[index] = el)
            }
          >
            {translatedExpenseTypes[item] || item}
          </EntriesTableCell>
        ))}
    </Collapse>
  ) : null;
};

export default CollapsibleHeaders;
